import { render, staticRenderFns } from "./CourseStudentNotStartedPage.vue?vue&type=template&id=3901b3a2&scoped=true"
import script from "./CourseStudentNotStartedPage.vue?vue&type=script&lang=js"
export * from "./CourseStudentNotStartedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901b3a2",
  null
  
)

export default component.exports